import { writable } from "svelte/store";
export let dataToRender = writable({});
export let modalIsOpen = writable({});